import { ArticleCard, MediaQueries, ThemeProps } from '@hhgtech/hhg-components'
import styled from 'styled-components'
import { deviceLayout } from 'styles/breakpoint'

import { StyledContainer } from '../../atoms/container/index.styled'

export const StyledArticleCard = styled(ArticleCard)`
  button {
    border: none;
  }
  p,
  .title {
    line-height: 1.5;
  }
  .author {
    .avatar {
      position: relative;
    }
    .poster {
      p {
        color: #404040;
        font-size: 13px;
        span {
          color: #404040;
        }
      }
    }
  }

  &[data-type='group2'] {
    .content {
      padding-bottom: 1.5rem;
    }
  }

  ${deviceLayout.spLayout`
    width: calc(100% + 2rem);
    margin-right: -1rem;
    margin-left: -1rem;
  `}

  ${deviceLayout.pcLayout`
    &[data-type='group1'][data-size='sm'] {

      padding: 1em 0;

      .banner {
        overflow: hidden;
        width: 28%;
        padding-top: 21%;
        margin-top: auto;
        margin-bottom: auto;
      }

      .content {
        width: calc(100% - 20% - 16px);

        .new {
          .title {
            font-size: 18px;
          }

          .text {
            display: -webkit-box;
            overflow: hidden;
            -webkit-box-orient: vertical;
            font-size: 14px;
            -webkit-line-clamp: 2;
          }
        }
      }

      .author {
        .avatar {
          width: 32px;
          height: 32px;
        }

        .poster {
          p {
            font-size: 14px;
          }
        }
      }
    }
  `};
`
export const NextArticleDivider = styled.div`
  width: 100%;
  height: 0.5em;
  background: ${(props: ThemeProps) => props.theme.colors.neutral50};
`
export const StyledBreadcrumbsWrapper = styled.div`
  position: relative;
  padding: 1rem 0 1rem;
  background: white;

  .translate-button {
    position: absolute;
    top: 0.5rem;
    right: 0;
  }

  .ampSpacer {
    height: 100px;
    padding-bottom: 12px;
  }

  .article-breadcrumb {
    div[data-last='true'] > a {
      color: rgb(38, 38, 38);
    }
  }
`
export const StyledLoadingWrapper = styled.div`
  margin-bottom: 4em;
  opacity: 0;
  transition: opacity 3s ease;
  &[data-show='true'] {
    opacity: 1;
    transition: opacity 0.3s ease;
  }
`
export const StyledNextPostWrapper = styled.div`
  padding: 0;
  margin-bottom: 0.5rem;
  background: ${(props: ThemeProps) => props.theme.colors.white};
  ${deviceLayout.pcLayout`
    padding: 0.5rem 0 0;
    margin-bottom: 0;
  `}
`

export const StyledPregnancyArticleTopContainer = styled.div`
  .breadcrumb-bg {
    background-color: ${(props: ThemeProps) => props.theme.mbColors.lightPink};
  }

  .breadcrumb-container {
    background-color: ${(props: ThemeProps) =>
      props.theme.mbColors.lightOrange};

    ${MediaQueries.mbDown} {
      border-radius: 16px 16px 0 0;
    }
  }

  .article-breadcrumb {
    padding: 24px 0;

    ${MediaQueries.mbDown} {
      padding: 16px 0;
      border-bottom: 1px solid #f3f3f3;
    }
  }

  .week-scroll {
    margin: 0 0 32px;

    ${MediaQueries.mbDown} {
      margin: 0;
    }
    &:before {
      border-radius: 0 0 100% 100% / 50%;

      ${MediaQueries.mbDown} {
        border-radius: 0;
      }
    }

    .main-content {
      padding: 0px 0px 92px;

      ${MediaQueries.mbDown} {
        padding: 16px 0px 48px;
      }
    }
  }
`

export const StyledContentContainer = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${(props: ThemeProps) => props.theme.colors.white};

  ${MediaQueries.mbDown} {
    position: relative;
    padding-top: 24px;
    border-radius: 16px 16px 0 0;
    margin-top: -16px;
  }
`

export const StyledArticlePageContainer = styled(StyledContainer)`
  position: relative;
  --author-width: 330px;
  --author-avatar-width: min(64px, calc(0.2 * var(--author-width)));
  .full-width {
    ${MediaQueries.mbUp} {
      margin-left: calc((-1 * (100vw - min(1170px, 100vw)) / 2) - 90px);
      width: 100vw;
    }
  }
  .article-bottom-ad {
    margin-bottom: 3rem;
    @supports (margin-bottom: env(safe-area-inset-bottom)) {
      margin-bottom: calc(env(safe-area-inset-bottom) + 3rem);
    }

    ${deviceLayout.spLayout`
      @supports (margin-bottom: env(safe-area-inset-bottom)) {
        bottom: calc(32px - env(safe-area-inset-bottom));
      }
    `}
  }
  ${deviceLayout.pcLayout`
    display: flex;
    justify-content: center;
    background: white;
    padding-left: 90px;
    padding-right: calc(var(--author-width) + 3em);
    .article-bottom-ad {
      margin-bottom: 0;
    }
  `}
`
export const StyledArticlePageMainWrapper = styled.div`
  position: relative;
  min-height: 100vh;
  ${deviceLayout.pcLayout`
    flex: 1;
    max-width: 100%;
  `}
`
export const StyledArticlePageLeftWrapper = styled.div`
  position: relative;
`

export const StyledBottomScrollDetect = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 450vh;
  pointer-events: none;
`
